<div>

  <h1>User List</h1>
  <div class="user-item" *ngFor="let user of users">
    <div class="flex items-center">

      <p>{{user.email}}</p>
      <button (click)="add.emit(user.id)" data-test="add-button" class="bg-blue-100">Add to Collection</button>

    </div>
  </div>

</div>
